export class Footer {
  constructor() {
    this.elementmenu = document.querySelectorAll('.nav-col .menu-item a');
  }
  init() {
    if(!this.elementmenu){
        return false;
    }
    this.elementmenu.forEach((item) => {
      if (item.getAttribute('href') == null) {
        item.classList.add('disabled');
      }
    });
  }
}
